// extracted by mini-css-extract-plugin
export default {"paddingSnackbar":"style-module--paddingSnackbar--a8d2d"};